import React from 'react';
import './App.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SocialLinks from './components/SocialLinks';
import EmailLink from './components/EmailLink';
import ChatWidget from './components/ChatWidget';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Skills from './pages/Skills';
import Projects from './pages/Projects';
import Interests from './pages/Interests';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Home />
        <About />
        <Skills />
        <Projects />
        <Interests />
        <Contact />
      </main>
      <SocialLinks />
      <EmailLink />
      <ChatWidget />
      <Footer />
    </div>
  );
}

export default App;
